/**
 * Sticky compact buy bar.
 *
 * Watches the main product buy buttons via IntersectionObserver. When
 * they leave the viewport, the bar slides up. Tapping its Add button
 * forwards the click to the real .product-form__submit so we reuse all
 * of Dawn's variant + cart logic (no duplicate state).
 */
(function () {
  const bar = document.querySelector('[data-bot-sticky-buy]');
  if (!bar) return;

  const targetId = bar.dataset.targetId;
  const formId = bar.dataset.formId;
  const target = targetId ? document.getElementById(targetId) : null;
  const form = formId ? document.getElementById(formId) : null;
  const realSubmit = form ? form.querySelector('.product-form__submit') : null;
  const stickyAdd = bar.querySelector('[data-bot-sticky-buy-add]');
  const stickyLabel = bar.querySelector('[data-bot-sticky-buy-label]');

  if (!target || !realSubmit || !stickyAdd) return;

  // Show the bar only when the main buy buttons are scrolled out of view AND
  // the user has scrolled at least one viewport down (prevents flash on load).
  let scrolled = false;
  const onScroll = () => {
    if (window.scrollY > 200) {
      scrolled = true;
      window.removeEventListener('scroll', onScroll);
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!scrolled) return;
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    },
    { rootMargin: '0px 0px -20px 0px', threshold: 0 }
  );

  observer.observe(target);

  // Post directly to /cart/add.js. cart-drawer.js wraps window.fetch and
  // opens the drawer whenever it sees /cart/add succeed, so going through
  // it directly is the simplest path: no dependency on Dawn's product-form
  // custom element (which expects a cart-notification element this theme
  // doesn't ship).
  stickyAdd.addEventListener('click', (e) => {
    e.preventDefault();
    if (stickyAdd.disabled) return;
    stickyAdd.classList.add('is-loading');
    const formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .catch(() => {})
      .finally(() => stickyAdd.classList.remove('is-loading'));
  });

  // Mirror the real button's disabled/sold-out state when variants change.
  const syncFromReal = () => {
    stickyAdd.disabled = realSubmit.disabled;
    const realLabel = realSubmit.querySelector('span');
    if (realLabel && stickyLabel) {
      stickyLabel.textContent = realLabel.textContent.trim();
    }
  };

  const mo = new MutationObserver(syncFromReal);
  mo.observe(realSubmit, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
  syncFromReal();

  // Refresh price when variant changes (Dawn dispatches via the variant picker
  // by re-rendering #price-{section_id}; mirror by re-reading the rendered DOM)
  const priceTarget = bar.querySelector('[data-bot-sticky-buy-price]');
  if (priceTarget) {
    const sectionPriceEl = document.querySelector('[id^="price-"] .price');
    if (sectionPriceEl) {
      const priceMo = new MutationObserver(() => {
        priceTarget.innerHTML = sectionPriceEl.outerHTML;
      });
      priceMo.observe(sectionPriceEl.parentElement, { childList: true, subtree: true, characterData: true });
    }
  }
})();
